var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.543 7.10434C21.557 7.31534 21.557 7.52734 21.557 7.74034C21.557 14.2473 16.603 21.7503 7.547 21.7503V21.7463C4.872 21.7503 2.252 20.9843 0 19.5393C0.389 19.5863 0.78 19.6093 1.172 19.6103C3.39 19.6123 5.544 18.8683 7.287 17.4983C5.18 17.4583 3.332 16.0843 2.687 14.0783C3.425 14.2203 4.185 14.1913 4.91 13.9943C2.612 13.5303 0.96 11.5113 0.96 9.16734C0.96 9.14634 0.96 9.12534 0.96 9.10534C1.645 9.48734 2.411 9.69834 3.195 9.72134C1.031 8.27634 0.363 5.39834 1.67 3.14834C4.17 6.22434 7.859 8.09434 11.818 8.29334C11.421 6.58334 11.964 4.79134 13.242 3.58834C15.225 1.72334 18.344 1.81934 20.209 3.80234C21.312 3.58534 22.369 3.18034 23.336 2.60734C22.968 3.74734 22.199 4.71534 21.171 5.33134C22.148 5.21434 23.101 4.95334 24 4.55534C23.339 5.54434 22.507 6.40734 21.543 7.10434Z",
    fill: "url(#paint0_linear_1777_892)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1777_892",
    x1: 0,
    y1: 2.25,
    x2: 19.0875,
    y2: 25.7418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501945,
    stopColor: "#248694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB831"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter11);
export default __webpack_public_path__ + "static/media/twitter(1)1.cff200d132407112b901075f9e82cc2d.svg";
export { ForwardRef as ReactComponent };